import { GridColDef, GridColumnVisibilityModel, GridSortModel } from '@mui/x-data-grid';
import { UserWithClaims } from '@synergetx/puppet-interview-types';
import AdminPermissionSelect from 'adminManagement/AdminPermissionSelect';
import CopyableCell from '@components/CopyableCell';
import TableDate from '@components/TableDate';
import Typography from '@mui/material/Typography';

export const getUsersColumns = (
    refreshUsers: () => Promise<void> | void,
): GridColDef<UserWithClaims>[] => [
    {
        field: 'name',
        headerName: 'Name',
        flex: 0.8,
        minWidth: 140,
        renderCell: ({ value }) => (
            <Typography variant="body2" noWrap>
                {value || '—'}
            </Typography>
        ),
    },
    {
        field: 'email',
        headerName: 'Email',
        flex: 1.2,
        minWidth: 200,
        // The one thing on this screen an admin routinely pastes elsewhere.
        renderCell: ({ value }) => <CopyableCell value={value} label="Email" />,
    },
    {
        field: 'claims',
        headerName: 'User Role',
        width: 180,
        sortable: false,
        filterable: false,
        renderCell: ({ row }) => (
            <AdminPermissionSelect refreshUsers={refreshUsers} rowData={row} />
        ),
    },
    {
        field: 'id',
        headerName: 'User ID',
        width: 260,
        // Hidden by default: 28 characters of Firebase UID that nobody reads, only pastes. It is
        // one click away under Columns, and copies without hand-selecting when shown.
        renderCell: ({ value }) => <CopyableCell value={value} label="User ID" />,
    },
    {
        field: 'createdAt',
        headerName: 'Created',
        width: 150,
        renderCell: ({ value }) => <TableDate value={value} />,
    },
];

export const USERS_COLUMN_VISIBILITY: GridColumnVisibilityModel = {
    id: false,
};

export const USERS_INITIAL_SORT: GridSortModel = [{ field: 'email', sort: 'asc' }];
